<template>
  <div>
    <b-modal
      :hide-header="false"
      :hide-footer="true"
      content-class="modal-blue"
      id="first-friend-conversation-modal"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      :hide-header-close="false"
      :title="'თემა: '+serviceTitle"
      
      size="xl">
      <!-- Modal content -->
            
      
        <textarea class="form-control" placeholder="ჩაწერეთ შეტყობინება" style="height: 300px;" v-model="message"></textarea>

        <div class="w-50 mx-auto mt-4">
            <button class="btn btn-danger" @click="sentMessage(serviceID)">გაგზავნა</button>
        </div>

       



    </b-modal>

  </div>
</template>

<script>
 import firstFriendResource from '../../api/firstFriendResource';
 const firstFriendResourceObj=new firstFriendResource()

export default {

    


    props:['serviceID','serviceTitle'],
    data(){
        return{
            message:null,
             
        }

    },


            methods:{

                sentMessage(serviceID){

                        if(this.message){

                          firstFriendResourceObj.sentMessage(serviceID,this.message).then(response=>{
                                    this.$bvModal.hide('first-friend-conversation-modal');

                                    this.helpers.notifySuccessMessage('თქვენი შეტყობინება გაგზავნილია, იხილიეთ "ბოლო კომუნიკაციის" სექცია')

                                    setTimeout(()=>{
                                            location.reload()
                                    },5000)


                          })  

                        }else{
                            alert("გთხოვთ ჩაწეროთ შეტყობინება")
                        }
                }


            }


   
};
</script>

<style scoped>
 

</style>
 